import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: '500.component.html'
})
export class P500ErrorComponent implements OnInit {
    exceptionMsg: any = null;

    constructor(
        private activatedRoute: ActivatedRoute,
    ) { }

    async ngOnInit() {
        this.activatedRoute.queryParamMap.subscribe((params) => {
            this.exceptionMsg = params.get('message') ?? null
        });
    }
}
